"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = __importDefault(require("react"));
var useStyles = (0, core_1.makeStyles)(function (_theme) {
    return (0, core_1.createStyles)({
        buttonProgress: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            margin: 'auto'
        },
        backdropProgress: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: function (_a) {
                var dark = _a.dark;
                return dark ? 'black' : 'white';
            },
            opacity: 0.5
        }
    });
});
var PopUpLoading = function (_a) {
    var loading = _a.loading, dark = _a.dark;
    var classes = useStyles({ dark: dark });
    return (loading
        ? react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: classes === null || classes === void 0 ? void 0 : classes.backdropProgress }),
            react_1.default.createElement(core_1.CircularProgress, { size: 100, className: classes === null || classes === void 0 ? void 0 : classes.buttonProgress }))
        : null);
};
exports.default = PopUpLoading;
//# sourceMappingURL=PopUpLoading.js.map